import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { addFavorite, removeFavorite } from "../Redux/Cart_System";
import { getAllEventProduct } from "../Services/Operations/ProductAPI";
import { allEvent_Api } from "../Services/Operations/ProductAPI";
import Design from "./Products/Design";
import Footer from "./Components/Footer";
import EventFilter from "./EventFilter";

const SkeletonLoader = () => {
  return (
    <div className="skeleton-container">
      <div className="page-layout-wrapper" style={{ marginTop: "78px" }}>
        <aside className="sidebar1">
          <div className="skeleton-filter">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="skeleton-filter-item"></div>
            ))}
          </div>
        </aside>
        <section className="main-content" style={{ height: "90vh" }}>
          <div className="product-listing">
            <div className="product-grid">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="skeleton-product-card">
                  <div className="skeleton-image"></div>
                  <div className="skeleton-text short"></div>
                  <div className="skeleton-text medium"></div>
                  <div className="skeleton-text long"></div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

const EventOrder = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [productData, setProductData] = useState([]);
  const { tokenDetails } = useSelector((state) => state.user);
  const { configUrl } = useSelector((state) => state.cart);
  const favorites = useSelector((state) => state.cart.favorites);

  useEffect(() => {
    const fetchEventProducts = async () => {
      try {
        setIsLoading(true);
        const response = await allEvent_Api();
        console.log("Event Products API Response:", response);

        if (response.success && response.data && response.data.length > 0) {
          setProductData(response.data);
        } else {
          setProductData([]);
        }
      } catch (error) {
        console.error("Error fetching event products:", error);
        toast.error("Failed to load event products");
      } finally {
        setIsLoading(false);
      }
    };

    fetchEventProducts();
  }, []);

  const handleFavorite = (product) => {
    const isFavorite = favorites.some((item) => item.id === product.id);
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }

    const favoriteProduct = {
      id: product.id,
      menu_id: product.menu_id,
      category_id: product.category_id,
      subcategory_id: product.subcategory_id,
      name: product.name,
      slug: product.slug,
      image: product.image,
      menu_name: product.menu_name,
      menu_slug: product.menu_slug,
      category_name: product.category_name,
      category_slug: product.category_slug,
      subcategory_name: product.subcategory_name,
      subcategory_slug: product.subcategory_slug,
      size: product.size?.find((size) => size.size_id) || {},
    };

    if (isFavorite) {
      dispatch(removeFavorite(product.id));
    } else {
      dispatch(addFavorite(favoriteProduct));
    }
  };

  const clickProductDetailsHandler = (slug) => {
    navigate(`/detailsPage/${slug}`,{ state: { fromEventPage: true } });
  };

  if (isLoading) {
    return <SkeletonLoader />;
  }

  return (
    <div>
      <body className="body-container default is-ctl-shield-listing-with-seo-box is-ctl-product_list is-ctl- is-act-">
        <div
          className="cms-image-container is-cover"
          style={{ position: "relative" }}
        >
          <img
            width="100%"
            src="/Images/eventOrder.webp" 
            className="cms-image f_lazy desctop-image-view desctop-mobile-type"
            loading="lazy"
            data-object-fit="cover"
            style={{ height: "100%", objectFit: "fill", marginTop: "78px" }}
          />
        </div>

        <main className="content-main" style={{ backgroundColor: "white" }}>
          <div className="flashbags"></div>
          <div className="container-main">
            <div className="page-layout">
              <div className="page-layout-wrapper">
                {/* Filter section can be removed or customized for events */}

                <aside className="sidebar1">
                  <EventFilter
                    setProductData={setProductData}
                    productData={productData}
                  />
                </aside>

                <section
                  className="main-content"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="product-listing">
                    <div className="product-grid">
                      {productData && productData.length > 0 ? (
                        productData.map((product) => {
                          const isFavorite = favorites.some(
                            (item) => item.id === product.id
                          );
                          const discount =
                            product?.size?.[0]?.discount_percent || 0;

                          return (
                            <div
                              key={product?.id}
                              className="product-card"
                              style={{ position: "relative" }}
                            >
                              <div className="product-box">
                                {discount > 0 && (
                                  <div className="discount-badge pulse-animation">
                                    <span style={{ fontSize: "14px" }}>
                                      {discount}% OFF
                                    </span>
                                  </div>
                                )}
                                <span
                                  onClick={() => handleFavorite(product)}
                                  style={{
                                    padding: "5px 10px",
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    borderRadius: "20px",
                                    fontSize: "0.9rem",
                                    zIndex: "2",
                                    fontSize: "17px",
                                  }}
                                >
                                  {isFavorite ? (
                                    <FaHeart color="red" />
                                  ) : (
                                    <FaRegHeart color="grey" />
                                  )}
                                </span>
                                <div
                                  className="product-image-wrapper"
                                  onClick={() =>
                                    clickProductDetailsHandler(product?.slug)
                                  }
                                >
                                  <a
                                    href=" "
                                    className="product-link1"
                                    style={{ height: "100%" }}
                                  >
                                    <img
                                      src={`${product?.image}`}
                                      alt={product?.name}
                                      className="product-image"
                                      style={{
                                        width: "100%",
                                        maxHeight: "100%",
                                        height: "100%",
                                      }}
                                    />
                                    {product?.second_image && (
                                      <img
                                        src={`${configUrl}${product?.second_image}`}
                                        alt={product?.name}
                                        className="hover-image"
                                      />
                                    )}
                                  </a>
                                </div>
                                <div className="product-info">
                                  <a
                                    href={product.link}
                                    className="product-name"
                                    style={{
                                      display: "inline-block",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "97%",
                                      verticalAlign: "middle",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <span
                                      onClick={() =>
                                        clickProductDetailsHandler(
                                          product?.slug
                                        )
                                      }
                                    >
                                      {product?.name}
                                    </span>
                                  </a>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div
                                      className="product-price"
                                      style={{
                                        marginTop: "0px",
                                        color: "#fa0707",
                                      }}
                                    >
                                      PRICE:{" "}
                                      <span>
                                        ${product?.size?.[0]?.price || "N/A"}
                                      </span>
                                    </div>
                                    {product?.size?.[0]?.mrp && (
                                      <div
                                        className="product-mrp"
                                        style={{ fontSize: "12px" }}
                                      >
                                        <span className="mrp">
                                          MRP: ${product?.size[0]?.mrp}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div
                          className="product-grid"
                          style={{ height: "100%" }}
                        >
                          {window.innerWidth <= 568 ? (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                  fontSize: "6vw",
                                  fontWeight: "bold",
                                }}
                              >
                                COMING SOON
                              </p>
                            </div>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "center",
                                  fontSize: "6vw",
                                  fontWeight: "bold",
                                }}
                              >
                                COMING SOON
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </main>
        <Design />
        <Footer />
      </body>
    </div>
  );
};

export default EventOrder;
